module.exports = __webpack_public_path__ + "img/vat_definition.9c0645cc.png";